import uses_color_palette from "../../../mixins/UsesColorPalette"

var report = {
    mixins: [uses_color_palette],
    props: {
        rawData: {
            type: Array | Object,
            required: true
        },
        datasetId: {
            type: String
        },
        filter: {
            type: String,
            default: ""
        },
        legendPosition: {
            type: String,
            default: "right"
        },
        utilityData: {
            default: null
        }
    }
}

export default report
